import './BlogHighlightCarousel.css';
import React, { useState } from 'react';
import { Carousel } from 'primereact/carousel';
import { Button } from 'primereact/button';
import { useMediaQuery } from 'react-responsive';

import iconNext from '../Assets/Images/iconNext.svg';
import iconPrevious from '../Assets/Images/iconPrevious.svg';

import { getSlugWithId } from './Utils'; // ou ajuste o path conforme sua estrutura
import { useNavigate } from 'react-router-dom';

const BlogHighlightCarousel = ({ posts = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();

const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' })  

  const handleClick = (post) => {
    const url = getSlugWithId(post.title?.rendered, post.id);
    navigate(url);
  };

  const itemTemplate = (post) => {
						
      const midia = post._embedded?.['wp:featuredmedia']?.[0];
      const image = midia?.media_details?.sizes?.large?.source_url
      || midia?.media_details?.sizes?.medium?.source_url
      || midia?.source_url;	      

    const title = post.title?.rendered || 'Sem título';
    const category = post._embedded?.['wp:term']?.[0]?.[0]?.name || 'Sem categoria';
    const description = post.excerpt?.rendered || '';

    return (
      <div className="carouselHighlight__item wrapper_carousel_block applyPointer" onClick={() => handleClick(post)} style={{flexDirection:isMobile ? "column" : "row"}}>
        <div className="carouselHighlight__imgContainer">
          <img src={image} alt={title} style={{width:isMobile ? "100%" : "34.9375rem"}} />
        </div>
        <div className="carouselHighlight__content">
          <span className="carouselHighlight__tag">{category}</span>
          <h3 className="carouselHighlight__title" dangerouslySetInnerHTML={{ __html: title }} />
          <p className="carouselHighlight__desc" dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </div>
    );
  };

  const nextSlide = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % posts.length);
  };

  const previousSlide = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + posts.length) % posts.length);
  };

  return (
    <div className="wrapper_carousel" style={{ marginTop: '0.25rem' }}>
      <div className="carouselHighlight__controls">
        <div className="previousButton">
          <Button
            icon={<img src={iconPrevious} alt="Anterior" className="iconSvg" />}
            className="previousButton"
            onClick={previousSlide}
          />
        </div>
        <div className="nextButton">
          <Button
            icon={<img src={iconNext} alt="Próximo" className="iconSvg" />}
            className="nextButton"
            onClick={nextSlide}
          />
        </div>
      </div>

      <Carousel
        value={posts}
        numVisible={1}
        numScroll={1}
        itemTemplate={itemTemplate}
        page={activeIndex}
        onPageChange={(e) => setActiveIndex(e.page)}
        showIndicators={true}
        showNavigators={false}
        className="carouselHighlight"
      />
    </div>
  );
};

export default BlogHighlightCarousel;
